/*eslint-disable */

import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
export default {
  name: 'payment-confirmation',
  components: {},
  props: [],
  data() {
    return {
      preloader: true,
      order_id: '',
      paymentConfirmationStatus: Boolean
    }
  },
  computed: {
    ...mapGetters([
      'getPaypalConfirmationDetailsState'
    ]),
    getPaymentConfirmationDetails() {
      let orderId = localStorage.getItem('ReturnId');
      let data = {
        order_id: orderId
      }
      this.$store.dispatch('getPaypalPaymentConfirmationById', data).then((res) => {
        //debugger
        console.log(res.data)
        if (res.data.code == '2000') {
          this.preloader = false
          toast.success(res.data.data.msg);
          localStorage.removeItem('ReturnId')
          this.paymentConfirmationStatus = true
        } else if (res.data.code == '2001') {
          this.preloader = false
          toast.error(res.data.data.msg);
          this.paymentConfirmationStatus = false
          // localStorage.removeItem('ReturnId')
        }
      }).catch((err) => {})
    }
  },
  mounted() {
    this.getPaymentConfirmationDetails
    setTimeout(() => {
      this.preloader = false;
      $('.app-loader').hide()
    }, 800);
  },
  methods: {

  }
}